import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencil = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "icon/content/create_24px",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "icon/content/create_24px_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.369 3.29L20.709 5.63C21.099 6.02 21.099 6.65 20.709 7.04L18.879 8.87L15.129 5.12L16.959 3.29C17.149 3.1 17.399 3 17.659 3C17.919 3 18.169 3.09 18.369 3.29ZM2.99902 17.25V21H6.74902L17.809 9.94L14.059 6.19L2.99902 17.25ZM5.91902 19H4.99902V18.08L14.059 9.02L14.979 9.94L5.91902 19Z",
				fill: "#2771bb"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0",
				"mask-type": "alpha",
				maskUnits: "userSpaceOnUse",
				x: 2,
				y: 3,
				width: 24,
				height: 18,
				children: /* @__PURE__ */ _jsx("path", {
					id: "icon/content/create_24px_3",
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M18.369 3.29L20.709 5.63C21.099 6.02 21.099 6.65 20.709 7.04L18.879 8.87L15.129 5.12L16.959 3.29C17.149 3.1 17.399 3 17.659 3C17.919 3 18.169 3.09 18.369 3.29ZM2.99902 17.25V21H6.74902L17.809 9.94L14.059 6.19L2.99902 17.25ZM5.91902 19H4.99902V18.08L14.059 9.02L14.979 9.94L5.91902 19Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", { mask: "url(#mask0)" })
		]
	})]
});
const ForwardRef = forwardRef(SvgPencil);
export default ForwardRef;
